export class AppConfig {
  private keycloakUrl: string;

  private keycloakRealm: string;

  private keycloakClientId: string;

  constructor(private config: any) {
    this.keycloakUrl = config.keycloakUrl;
    this.keycloakRealm = config.keycloakRealm;
    this.keycloakClientId = config.keycloakClientId;
  }

  getKeycloakUrl(): string {
    return this.keycloakUrl;
  }

  getKeycloakRealm(): string {
    return this.keycloakRealm;
  }

  getKeycloakClientId(): string {
    return this.keycloakClientId;
  }
}
